var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "monitor-summary mb-2" }, [
    _c("h2", { staticClass: "h4 mb-1" }, [
      _vm._v(" " + _vm._s(_vm.$t("Indicadores do período")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "monitor-summary__grid" },
      _vm._l(_vm.items, function (item) {
        return _c(
          "div",
          { key: item.key, staticClass: "monitor-summary__card" },
          [
            _c("span", { staticClass: "monitor-summary__value" }, [
              _vm._v(_vm._s(item.value)),
            ]),
            _c("span", { staticClass: "monitor-summary__label" }, [
              _vm._v(_vm._s(item.text)),
            ]),
            item.detail
              ? _c("small", { staticClass: "text-muted" }, [
                  _vm._v(" " + _vm._s(item.detail) + " "),
                ])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }